import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '@fantaz/shared/ui/material';

interface PromoCodeDialogMessage {
  promoCode: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, MaterialModule],
  selector: 'fz-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoCodeMessageDialogComponent {
  constructor(
    // inject dialog data
    @Inject(MAT_DIALOG_DATA) public readonly data: PromoCodeDialogMessage,
    private readonly dialogRef: MatDialogRef<PromoCodeMessageDialogComponent>,
  ) {}

  close(event: MouseEvent) {
    event.preventDefault();
    this.dialogRef.close();
  }

  redirect() {
    this.dialogRef.close();
  }

  goTo(url: string): void {
    // got to url
    window.location.href = url;
  }
}
